import { CategoryDetail, categoryDetailSchema } from '@/schemas/category'
import { API_ENDPOINT } from '../../utils/api-client/api-endpoint'
import { handleActionRequest } from '../../utils/handle-action-request'
import { APIResponse } from '@/schemas/api-response'

export const getCategoryByIdAction = async ({
  id,
}: {
  id: string
}): Promise<APIResponse<CategoryDetail>> => {
  return handleActionRequest<CategoryDetail>({
    endpoint: API_ENDPOINT.category.getCategory(id),
    schema: categoryDetailSchema,
  })
}
